<template>
  <h1 class="text-center">Breadcrumbs</h1>
</template>

<script>
export default {
  name: "Breadcrumbs"
}
</script>

<style scoped>

</style>